<template lang="pug">
  v-container
    v-row
      v-col
        v-list
          v-list-item(
            v-for="affiliation in affiliations"
            :key="affiliation.id")
            v-list-item-avatar
              v-img(
                :lazy-src="affiliation.image.srcLazy"
                :src="affiliation.image.src")
            v-list-item-content
              v-list-item-title {{ affiliation.name }}
            v-list-item-action.ml-3
              v-btn(
                @click="onClickEdit({ id: affiliation.id })"
                icon)
                v-icon {{ mdiPencil }}
            v-list-item-action
              v-btn(
                @click="onClickRemove({ id: affiliation.id })"
                icon)
                v-icon {{ mdiDelete }}
</template>

<script>
import { page } from '@iez/core'
//import affiliation from '@iez/lib/affiliation/'
import data from '@iez/lib/data/'
import { mdiPlus, mdiPencil, mdiDelete } from '@mdi/js'
import router from '@iez/core/router'

const route = {
  name: `ManageAffiliation`,
  path: `/manage-affiliation`
}

export default {
  ...route,

  setup () {
    page.topBar.set({
      title: `Gestion des Affiliations`
    })
    page.bottomShortcut.add({
      action: {
        label: `Ajouter une affiliation`,
        icon: mdiPlus,
        onClick: () => {
          router.push({
            name: `ManageAffiliationAdd`
          })
        }
      }
    })

    const affiliations = data.get({
      root: `affiliations`,
      fields: [
        `id`,
        `name`,
        `link`,
        `message`, {
          image: [
            `id`,
            `src`,
            `srcLazy`
          ]
        }
      ]
    })

    const onClickEdit = ({ id }) => {
      router.push({
        name: `ManageAffiliationAdd`,
        params: {
          id
        }
      })
    }

    const onClickRemove = ({ id }) => {
      data.remove({
        root: `affiliations`,
        ids: [id],
        parents: []
      })
    } 

    return {
      affiliations,
      mdiPencil,
      mdiDelete,
      onClickEdit,
      onClickRemove
    }
  }
}
</script>
